import React, { Fragment, useContext, useEffect, useState, useRef } from "react";
import Grid from "@mui/material/Grid";
import { AlertContext } from "../../../context/AlertContext";
import { ConfiguracionContext } from "../../../context/ConfiguracionContext";
import Spinner from "./../Spinner";
import { AuthContext } from "../../../context/AuthContext";
import { Button } from "primereact/button";
import "../../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Tag } from "primereact/tag";
import ButtonMui from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { useNavigate } from "react-router-dom";
import Menu from "./../Menu";
import { MultiSelect } from "primereact/multiselect";
import { InputMask } from "primereact/inputmask";
import { saveAs } from "file-saver";
import clienteAxios from "../../../config/axios";

const formatoImporte = (valor) =>
  Number(valor).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const sumar = (lista, campo) =>
  lista.reduce((acc, item) => acc + Number(item[campo]), 0);

export default function ListadosCobranzasResumen(props) {
  const [visibleFechas, setVisibleFechas] = useState(true);
  const [periodo, setPeriodo] = useState(null);
  const [selectedCities, setSelectedCities] = useState([]);
  const [bandInicio, setBandInicio] = useState(false);

  const toast = useRef(null);

  let navigate = useNavigate();

  //Context

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state } = authContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const { statusAcceso, empresaElegida, empresas, obtenerAcceso, obtenerEmpresas } =
    configuracionContext;

  useEffect(() => {
    if (state.usuario) {
      // Usa el mismo permiso que Cobranzas Realizadas
      obtenerAcceso({
        usuarioId: state.usuario.id,
        layout: "ListadosCobranzasRealizadas",
      });
    }
  }, [state.id]);

  useEffect(() => {
    obtenerEmpresas();
  }, []);

  const exitClick = (e) => {
    navigate("/");
  };

  const onHideFechas = (e) => {
    setVisibleFechas(false);
  };

  const periodoValido = (valor) => {
    if (!valor || !/^\d{2}\/\d{2}$/.test(valor)) return false;
    const mes = Number(valor.substring(0, 2));
    return mes >= 1 && mes <= 12;
  };

  const aceptarFechas = async (exportType) => {
    //Validar

    if (!periodoValido(periodo)) {
      mensajeAlerta(
        "Listado Resumen",
        "Debe indicar un período válido (MM/AA) !.",
        "error"
      );
      return;
    }

    if (selectedCities && selectedCities.length === 0) {
      mensajeAlerta(
        "Listado Resumen",
        "Debe indicar al menos una empresa !.",
        "error"
      );
      return;
    }

    toast.current.show({
      severity: "info",
      summary: "Listados",
      detail: "Obteniendo información... !",
      life: 3000,
    });

    let data;
    try {
      const respuesta = await clienteAxios.post(
        "/api/configuracion/obtenercobranzasresumen",
        { periodo, selectedCities }
      );
      data = respuesta.data;
    } catch (error) {
      console.log(error.response);
      mensajeAlerta(
        "Listado Resumen",
        "Hubo un error al obtener la información !.",
        "error"
      );
      return;
    }

    if (
      !data ||
      (data.movimientos.length === 0 && data.importes.length === 0)
    ) {
      mensajeAlerta(
        "Listado Resumen",
        "No hay información para el período indicado !.",
        "error"
      );
      return;
    }

    // Filas TOTAL
    const movimientos = [
      ...data.movimientos,
      {
        grupo: "TOTAL",
        altas: sumar(data.movimientos, "altas"),
        bajas: sumar(data.movimientos, "bajas"),
        neto: sumar(data.movimientos, "neto"),
        altasImporte: sumar(data.movimientos, "altasImporte"),
        bajasImporte: sumar(data.movimientos, "bajasImporte"),
        netoImporte: sumar(data.movimientos, "netoImporte"),
      },
    ];
    const importes = [
      ...data.importes,
      {
        grupo: "TOTAL",
        cantidad: sumar(data.importes, "cantidad"),
        facturacion: sumar(data.importes, "facturacion"),
        cobranzasCantidad: sumar(data.importes, "cobranzasCantidad"),
        cobranzas: sumar(data.importes, "cobranzas"),
        netoCantidad: sumar(data.importes, "netoCantidad"),
        neto: sumar(data.importes, "neto"),
      },
    ];

    if (exportType === "excel") {
      exportExcel(movimientos, importes);
    } else {
      exportPdf(movimientos, importes);
    }
  };

  const textoEmpresas = () =>
    selectedCities.map((item) => item.nombre).join(" - ");

  const exportExcel = (movimientos, importes) => {
    const hojaMovimientos = movimientos.map((fila) => ({
      Grupo: fila.grupo,
      Altas: fila.altas,
      "Importe Altas": Number(fila.altasImporte.toFixed(2)),
      Bajas: fila.bajas,
      "Importe Bajas": Number(fila.bajasImporte.toFixed(2)),
      Neto: fila.neto,
      "Importe Neto": Number(fila.netoImporte.toFixed(2)),
    }));
    const hojaImportes = importes.map((fila) => ({
      Grupo: fila.grupo,
      Cantidad: fila.cantidad,
      Facturacion: Number(fila.facturacion.toFixed(2)),
      "Cantidad Cobranzas": fila.cobranzasCantidad,
      Cobranzas: Number(fila.cobranzas.toFixed(2)),
      "Cantidad Neto": fila.netoCantidad,
      Neto: Number(fila.neto.toFixed(2)),
    }));

    import("xlsx").then((xlsx) => {
      const workbook = {
        Sheets: {
          altasbajas: xlsx.utils.json_to_sheet(hojaMovimientos),
          facturacion: xlsx.utils.json_to_sheet(hojaImportes),
        },
        SheetNames: ["altasbajas", "facturacion"],
      };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
      saveAs(
        blob,
        "listadoResumen_" +
          periodo.replace("/", "-") +
          "_" +
          new Date().getTime() +
          ".xlsx"
      );
    });
  };

  const exportPdf = (movimientos, importes) => {
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        const doc = new jsPDF.default("p");
        doc.setFontSize(12);
        doc.text("Listado Resumen", 10, 10);
        doc.setFontSize(8);
        doc.text(`Empresas: ${textoEmpresas()}`, 10, 16);
        doc.text(`Período: ${periodo}`, 10, 21);

        const estiloTabla = (cantidadFilas) => ({
          margin: { left: 10, right: 10 },
          styles: { fontSize: 8 },
          columnStyles: {
            1: { halign: "right" },
            2: { halign: "right" },
            3: { halign: "right" },
            4: { halign: "right" },
            5: { halign: "right" },
            6: { halign: "right" },
          },
          didParseCell: (data) => {
            if (data.cell && data.cell.section === "head") {
              data.cell.styles.halign =
                data.column.index === 0 ? "left" : "right";
            }
            if (
              data.cell &&
              data.cell.section === "body" &&
              data.row.index === cantidadFilas - 1
            ) {
              data.cell.styles.fontStyle = "bold";
            }
          },
        });

        doc.autoTable(
          [
            { title: "Grupo", dataKey: "grupo" },
            { title: "Altas", dataKey: "altas" },
            { title: "Importe", dataKey: "altasImporte" },
            { title: "Bajas", dataKey: "bajas" },
            { title: "Importe", dataKey: "bajasImporte" },
            { title: "Neto", dataKey: "neto" },
            { title: "Importe", dataKey: "netoImporte" },
          ],
          movimientos.map((fila) => ({
            ...fila,
            altasImporte: formatoImporte(fila.altasImporte),
            bajasImporte: formatoImporte(fila.bajasImporte),
            netoImporte: formatoImporte(fila.netoImporte),
          })),
          { ...estiloTabla(movimientos.length), startY: 26 }
        );

        doc.autoTable(
          [
            { title: "Grupo", dataKey: "grupo" },
            { title: "Cantidad", dataKey: "cantidad" },
            { title: "Facturación", dataKey: "facturacion" },
            { title: "Cantidad", dataKey: "cobranzasCantidad" },
            { title: "Cobranzas", dataKey: "cobranzas" },
            { title: "Cantidad", dataKey: "netoCantidad" },
            { title: "Neto", dataKey: "neto" },
          ],
          importes.map((fila) => ({
            grupo: fila.grupo,
            cantidad: fila.cantidad,
            cobranzasCantidad: fila.cobranzasCantidad,
            netoCantidad: fila.netoCantidad,
            facturacion: formatoImporte(fila.facturacion),
            cobranzas: formatoImporte(fila.cobranzas),
            neto: formatoImporte(fila.neto),
          })),
          { ...estiloTabla(importes.length), startY: doc.lastAutoTable.finalY + 10 }
        );

        window.open(doc.output("bloburl"));
      });
    });
  };

  const accesoDenegado = () => {
    mensajeAlerta(
      "Listado Resumen",
      "No tiene permiso para acceder a esta pantalla !.",
      "error"
    );
    exitClick();
    return;
  };

  const renderHeaderFechas = () => {
    return (
      <div>
        <Tag value="Listado Resumen"></Tag>
      </div>
    );
  };

  const renderFooterFechas = () => {
    return (
      <div>
        <Button
          icon="pi pi-file-excel"
          onClick={(e) => {
            aceptarFechas("excel");
          }}
          className="p-button-raised p-button-success"
          data-pr-tooltip="XLS"
          label="Excel"
        />
        <Button
          icon="pi pi-file-pdf"
          onClick={(e) => {
            aceptarFechas("pdf");
          }}
          className="p-button-raised p-button-warning"
          data-pr-tooltip="PDF"
          style={{ marginRight: "1em" }}
          label="PDF"
        />
        <ButtonMui
          onClick={onHideFechas}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
      </div>
    );
  };

  // INICIO

  if (!bandInicio && empresas && empresas.length > 0 && empresaElegida) {
    setBandInicio(true);
    const index = empresas.findIndex((item) => item.id === empresaElegida.id);
    if (index !== -1) {
      let final = [];
      final.push(empresas[index]);
      setSelectedCities(final);
    }
  }

  // FIN

  return (
    <Fragment>
      <Menu />
      <Toast ref={toast} />
      {statusAcceso === 0 ? <Spinner /> : null}
      {statusAcceso === 400 ? accesoDenegado() : null}
      {statusAcceso === 200 ? (
        <Fragment>
          <Dialog
            header={renderHeaderFechas()}
            visible={visibleFechas}
            closable={false}
            footer={renderFooterFechas()}
            breakpoints={{ "960px": "90vw" }}
            style={{ width: "90vw", paddingBottom: "0" }}
            position="top"
          >
            <Grid container spacing={3} style={{ marginTop: "1vw" }}>
              <Grid item xs={12} md={2}>
                <label htmlFor="periodo">Período: </label>
                <InputMask
                  id="periodo"
                  mask="99/99"
                  value={periodo}
                  placeholder="99/99"
                  size={5}
                  style={{ marginLeft: "1vw" }}
                  onChange={(e) => setPeriodo(e.value)}
                />
              </Grid>

              <Grid
                item
                xs={12}
                md={12}
                style={{ paddingLeft: "1vw", marginTop: "1vw" }}
              >
                <label htmlFor="id">Empresas</label>

                <MultiSelect
                  value={selectedCities}
                  onChange={(e) => setSelectedCities(e.value)}
                  options={
                    empresas ? empresas.filter((item) => item.habilitado) : null
                  }
                  optionLabel="nombre"
                  placeholder="Seleccione las empresas"
                  maxSelectedLabels={10}
                  display="chip"
                  style={{ marginLeft: "1vw" }}
                />
              </Grid>
            </Grid>
          </Dialog>
        </Fragment>
      ) : null}
      <Grid item xs={12} sm={12}></Grid>
    </Fragment>
  );
}
